<script>
import api from '@utils/api'

export default {
  name: 'UserDelete',
  props: {
    userId: {
      type: Number,
      required: true,
      default: 0,
    },
    username: {
      type: String,
      required: true,
      default: '0',
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  methods: {
    deleteUser() {
      this.loading = true
      api.deleteUser(this.userId).then(response => {
        this.dialog = false
        this.$emit('user-deleted')
        this.loading = false
        this.$store.dispatch('data/updateDictionary', 'user')
      })
    },
  },
}
</script>

<template>
  <v-layout row>
    <v-btn
      slot="activator"
      color="error"
      flat
      icon
      @click.native.stop="dialog = true">
      <v-icon>delete</v-icon>
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="355">
      <v-card>
        <v-card-title class="headline text-xs-center">
          <v-spacer />
          {{ $t('titles__delete_user') }} {{ username }}
          <v-spacer />
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="loading"
            color="secondary"
            @click.native="dialog = false"
          >
            {{ $t('buttons__cancel') }}
          </v-btn>
          <v-btn
            :disabled="loading"
            :loading="loading"
            color="error"
            @click.native="deleteUser"
          >
            {{ $t('buttons__delete') }}
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
